"use client";

import { openClosableSubscribeDialog } from "@/context/redux/reducers/dialog/subscribe-dialog-slice";
import { tableCellStyles } from "@/features/analysis/value/value-earnings-table/data/table-cell-style";
import { useAppDispatch } from "@/hooks/redux-hooks";
import { Lang } from "@/i18n-config";
import { getTranslations } from "@/utils/i18n/get-translations";

import { Table } from "ui/core/table";
import LockIcon from "ui/icon/shared/LockIcon";

type Props = {
  lang: Lang;
};

const CELL_COUNT = 7;

const getHeader = (lang: Lang) => {
  const { t } = getTranslations(lang);
  return [
    t.analysis.overview.earningsTable.quarter,
    t.analysis.overview.earningsTable.nonGaaPEPS,
    t.analysis.overview.earningsTable.epsYoY,
    t.analysis.overview.earningsTable.epsSurprise,
    t.analysis.overview.earningsTable.sales,
    t.analysis.overview.earningsTable.salesYoY,
    t.analysis.overview.earningsTable.salesSurprise,
    t.analysis.overview.earningsTable.npm,
  ];
};

const getRows = (lang: Lang) => {
  const { t } = getTranslations(lang);
  const lastYear = new Date().getFullYear() - 1;
  const quarters = [
    t.analysis.overview.earningsTable.current,
    `${lastYear}Q4`,
    `${lastYear}Q3`,
    `${lastYear}Q2`,
    `${lastYear}Q1`,
  ];
  const rows = quarters.map(createLockedRow);
  return rows;
};

const createLockedRow = (quarter: string) => [
  quarter,
  ...Array(CELL_COUNT).fill(<LockCell />),
];

const LockCell = () => {
  const dispatch = useAppDispatch();
  return (
    <div
      className="group flex cursor-pointer justify-center p-2"
      onClick={() => dispatch(openClosableSubscribeDialog())}
    >
      <LockIcon className="w-2.5 text-zinc-500 group-hover:animate-shake" />
    </div>
  );
};

export const MockEarningsTable = ({ lang }: Props) => {
  const header = getHeader(lang);
  const rows = getRows(lang);

  return (
    <Table
      data={[header, ...rows]}
      tableHeaderStyles={tableCellStyles}
      tableCellStyles={tableCellStyles}
    />
  );
};
